import React from 'react';
import { PropertyAlertTriggersList } from '../property-alert-triggers-list';

export function PropertyAlertSubscriptions() {
  return <PropertyAlertTriggersList />;
}
